export enum TooltipSize {
  SMALL = "small",
  LARGE = "large",
}
